import React from 'react';

export default function Input({ label, error, style, ...props }) {
  return (
    <div style={{ marginBottom: 18, ...style }}>
      {label && (
        <label style={{
          display: 'block', marginBottom: 6,
          fontSize: 'var(--font-size-sm)', fontWeight: 600,
          color: 'var(--color-text)',
        }}>
          {label}
        </label>
      )}
      <input
        style={{
          width: '100%', padding: '10px 14px',
          border: `1.5px solid ${error ? 'var(--color-error)' : 'var(--color-border)'}`,
          borderRadius: 'var(--radius-sm)', fontSize: 'var(--font-size-base)',
          color: 'var(--color-text)', background: '#fff', outline: 'none',
          transition: 'border-color var(--transition)',
        }}
        {...props}
      />
      {error && (
        <p style={{ marginTop: 4, fontSize: 'var(--font-size-sm)', color: 'var(--color-error)' }}>
          {error}
        </p>
      )}
    </div>
  );
}

export function Select({ label, error, children, style, ...props }) {
  return (
    <div style={{ marginBottom: 18, ...style }}>
      {label && (
        <label style={{
          display: 'block', marginBottom: 6,
          fontSize: 'var(--font-size-sm)', fontWeight: 600, color: 'var(--color-text)',
        }}>
          {label}
        </label>
      )}
      <select
        style={{
          width: '100%', padding: '10px 14px',
          border: `1.5px solid ${error ? 'var(--color-error)' : 'var(--color-border)'}`,
          borderRadius: 'var(--radius-sm)', fontSize: 'var(--font-size-base)',
          color: 'var(--color-text)', background: '#fff', outline: 'none',
        }}
        {...props}
      >
        {children}
      </select>
      {error && <p style={{ marginTop: 4, fontSize: 'var(--font-size-sm)', color: 'var(--color-error)' }}>{error}</p>}
    </div>
  );
}
